import H2 from "@/atoms/text/H2";
import Tile from "@/molecules/Tile";
import { loadDynamicIcon } from "@/utils/functions";

const ConnectIntegration = ({
  bgColor,
  title,
  hasTitleDot = true,
  tileData,
  color,
}) => {
  const tilesData = tileData.map((tile, idx) => {
    let DynamicComponent;

    if (tile.icon) {
      DynamicComponent = loadDynamicIcon(tile.icon);
    }

    return (
      <li
        key={idx}
        className={idx === tileData.length - 1 ? "" : `mb-5 mb-reset-d`}
      >
        <Tile
          bgColor={tile.bgColor}
          logo={tile.logo}
          icon={tile.icon ? <DynamicComponent className="mb-3" /> : false}
          title={tile.title}
          content={tile.content}
          href={tile.href}
          isLargeTile={tile.isLargeTile}
          isLearnMore={tile.isLearnMore}
          hasTileTop={tile.hasTileTop}
          hasBorder={tile.hasBorder}
          isTileClickable={tile.isTileClickable}
          onClick={tile.href === "#" ? (e) => e.preventDefault() : undefined}
        />
      </li>
    );
  });

  return (
    <section className={`bc-${bgColor} pv-15-d pv-8`}>
      <div className="container ta-center">
        {title && (
          <H2
            color={color}
            className="mb-8-d mb-7 bold"
            dangerouslySetInnerHTML={{
              __html: `${title}${
                hasTitleDot ? '<span class="dot">.</span>' : ""
              }`,
            }}
          ></H2>
        )}
        <ul className="tile-wrapper w-100 fx-d fx--sb fx--cv fx--w">
          {tilesData}
          <style global jsx>{`
            .tile-wrapper {
              gap: 40px;
            }
            .tile--md {
              min-height: 270px;
            }
            @media (max-width: 1200px) {
              .tile-wrapper li {
                max-width: 335px;
                margin-left: auto;
                margin-right: auto;
              }
            }
          `}</style>
        </ul>
      </div>
    </section>
  );
};

ConnectIntegration.defaultProps = {
  bgColor: "blue-light",
  color: "black",
};

export default ConnectIntegration;
